<template>
<div class="content">
  <section class="content-file-browser" v-if="currentClient">
    <ToDoBrowser :key="currentClient.uuid" :hasUse="hasCallback" @doUse="callCallback" />
  </section>
  <section class="no-client-selected" v-else>
    Izaberite klijenta
  </section>
</div>
</template>

<script>
export default {
  data: ()=>({
    parent: null,
  }),
  props: [
    "params", "index", "active"
  ],
  computed: {
    currentClient() {
      return this.stores.auth.currentClient;
    },
    hasCallback() {
      return !!this.stores.callbacks.lastCallback;
    },
  },
  methods: {
  },
  created() {
    var title="Planirane aktivnosti";
    this.stores.page.pushPage(title, this.params.path, this.index);
  },
  unmounted() {
    this.stores.page.popPage();
  },

}
</script>
